export function LabMinusIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" className="size-3.5" {...props}>
      <path fill="currentColor" d="M3.5 6.35h7v1.4h-7z" />
    </svg>
  );
}
